<app-breadcrumb [title]="'Identificar Rutas'" [items]="['PESV', 'Diagnóstico']" [active_item]="'Identificar Rutas'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-road me-2"></i>
      <h5 class="mb-0"><strong>IDENTIFICAR RUTAS</strong></h5>
    </div>

    <div class="card-body custom-datatable noscroll my">
      <div class="row mb-3">
        <div class="col-sm-12 col-md-4 ms-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por id, nombre, ruta, origen o destino..."
              [(ngModel)]="filtro"
              (input)="aplicarFiltro()"
            />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="cargando" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <div *ngIf="!cargando" class="custom-datatable table-responsive my-4">
        <table class="table table-hover table-bordered" id="tblIdentificarRutasPesv">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>ID</strong></th>
              <th class="text-center" style="cursor: pointer" (click)="sortData('nombre_ruta')">
                <strong>NOMBRE DE LA RUTA</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'nombre_ruta' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'nombre_ruta' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'nombre_ruta'
                }"></i>
              </th>
              <th class="text-center" style="cursor: pointer" (click)="sortData('origen')">
                <strong>ORIGEN</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'origen' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'origen' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'origen'
                }"></i>
              </th>
              <th class="text-center" style="cursor: pointer" (click)="sortData('destino')">
                <strong>DESTINO</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'destino' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'destino' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'destino'
                }"></i>
              </th>
              <th class="text-center"><strong>KILÓMETROS RECORRIDOS</strong></th>
              <th class="text-center"><strong>TIPO DE RUTA</strong></th>
              <th class="text-center"><strong>FRECUENCIA DEL RECORRIDO</strong></th>
              <th class="text-center"><strong>NÚMERO DE VECES QUE SE USA LA RUTA</strong></th>
              <th class="text-center"><strong>ACCIONES</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ruta of rutasFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
              <td class="text-center">{{ ruta.id_ident_ruta || '-' }}</td>
              <td class="text-center">{{ ruta.nombre_ruta || ruta.nombre || '-' }}</td>
              <td class="text-center">
                {{ ruta.salida || ruta?.municipioOrigen?.MUNICIPIO || ruta.origen || '-' }}
              </td>
              <td class="text-center">
                {{ ruta.destino || ruta?.municipioDestino?.MUNICIPIO || '-' }}
              </td>
              <td class="text-center">
                <input type="number" class="form-control form-control-sm" [(ngModel)]="ruta.kilometros_recorridos" placeholder="Ingrese kilometros" />
              </td>
              <td class="text-center">
                <select
                  class="form-select form-select-sm"
                  [ngModel]="normalizarIdSeleccion(ruta.tipo_ruta)"
                  (ngModelChange)="ruta.tipo_ruta = normalizarIdSeleccion($event)"
                >
                  <option [ngValue]="null">Seleccione</option>
                  <option *ngFor="let tipo of tiposRuta" [ngValue]="tipo.id">{{ tipo.descripcion }}</option>
                </select>
              </td>
              <td class="text-center">
                <select
                  class="form-select form-select-sm"
                  [ngModel]="normalizarIdSeleccion(ruta.frecuencia_recorrido)"
                  (ngModelChange)="ruta.frecuencia_recorrido = normalizarIdSeleccion($event)"
                >
                  <option [ngValue]="null">Seleccione</option>
                  <option *ngFor="let frecuencia of frecuenciasRecorrido" [ngValue]="frecuencia.id">{{ frecuencia.descripcion }}</option>
                </select>
              </td>
              <td class="text-center">
                <input type="number" class="form-control form-control-sm" [(ngModel)]="ruta.usos_ruta" placeholder="Ingrese cantidad de usos" />
              </td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="guardarIdentRuta(ruta)"
                  [disabled]="guardandoTodo || ruta.guardando"
                >
                  {{ ruta.guardando ? 'Guardando...' : 'Guardar' }}
                </button>
              </td>
            </tr>
            <tr *ngIf="!rutasFiltradas.length">
              <td colspan="11" class="text-center py-3">No se encontraron rutas.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="!cargando" class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center">
          <label for="pageSizeIdentificarRutas" class="me-2">Mostrar:</label>
          <select id="pageSizeIdentificarRutas" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por pagina</span>
        </div>

        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary"><b>{{ rutasFiltradas?.length || 0 }}</b></a>
        </div>

        <div class="text-end paginador-personalizado">
          <pagination-controls
            (pageChange)="page = $event"
            [maxSize]="5"
            [directionLinks]="true"
            [autoHide]="true"
            previousLabel="Anterior"
            nextLabel="Siguiente"
          >
          </pagination-controls>
        </div>
      </div>

      <div class="mt-4" *ngIf="!cargando">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
            (click)="exportarExcel('tblIdentificarRutasPesv','listado_identificar_rutas_pesv')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
            (click)="exportToPDF('tblIdentificarRutasPesv','listado_identificar_rutas_pesv','Listado Identificar Rutas PESV')">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-primary"
            (click)="guardarTodoIdentRutas()"
            [disabled]="guardandoTodo || !rutasFiltradas.length"
          >
            {{ guardandoTodo ? 'Guardando...' : 'Guardar todo' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
